var React = require('react');

function PhoneIconSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.59 10.648c.273.11.41.31.41.602 0 .055-.01.1-.027.137l-.657 2.843a.477.477 0 01-.136.247.445.445 0 01-.22.191.527.527 0 01-.273.082c-3.5 0-6.49-1.24-8.968-3.719C1.239 8.552 0 5.562 0 2.062c0-.09.018-.182.055-.273a.753.753 0 01.191-.219.644.644 0 01.274-.136L3.363.777A.304.304 0 013.5.75c.292 0 .492.137.602.41l1.312 3.063a.543.543 0 01.055.246c0 .2-.082.373-.246.52l-1.641 1.34c.42.91 1.103 1.84 2.05 2.788.949.948 1.878 1.632 2.79 2.051l1.34-1.64a.673.673 0 01.52-.247c.09 0 .172.018.245.055l3.063 1.312z","fill":"#fff"}));
}

PhoneIconSmall.defaultProps = {"width":"14","height":"15","fill":"none"};

module.exports = PhoneIconSmall;

PhoneIconSmall.default = PhoneIconSmall;
